(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('NormaHistoricoVincularController', NormaHistoricoVincularController);

    NormaHistoricoVincularController.$inject = ['$uibModalInstance', '$filter', 'vigente', 'Norma', 'NormaSearch'];

    function NormaHistoricoVincularController($uibModalInstance, $filter, vigente, Norma, NormaSearch) {
        var vm = this;

        vm.vigente = vigente;  // la norma vigente que recibirá los históricos
        vm.seleccionadas = []; // las normas ya elegidas para vincular
        vm.modelNorma = null;
        vm.isSaving = false;
        vm.autocompleteNormas = autocompleteNormas;
        vm.agregar = agregar;
        vm.quitar = quitar;
        vm.save = save;
        vm.clear = clear;
        vm.etiqueta = etiqueta;

        // Misma forma de armar la consulta que usa el formulario de Norma
        function formatInput(input_query) {
            var output = "";
            if (input_query != null) {
                output = input_query.replace("/", "?");
            }
            return output.trim();
        }

        function formatInputQuery(input_query) {
            var query = "";
            var aux_input = formatInput(input_query);
            if (aux_input != null) {
                query = "\"^" + aux_input + "\"$";
                if (query.indexOf(" ") < 0) {
                    query = query + " and " + aux_input + "*";
                }
            }
            return query;
        }

        function yaElegida(id) {
            return vm.seleccionadas.some(function(norma) {
                return norma.id === id;
            });
        }

        // Muestra todas las normas, vigentes e históricas, que contengan el texto escrito
        function autocompleteNormas(texto) {
            return Norma.buscarVinculables({query: texto}).$promise.then(function(data) {
                return data.filter(function(norma) {
                    return norma.id !== vm.vigente.id && !yaElegida(norma.id);
                });
            });
        }

        function etiqueta(norma) {
            if (!norma) {
                return '';
            }
            var fecha;
            if (norma.fechaEmisionPend) {
                fecha = norma.fechaEmisionPendText;
            } else if (norma.fechaEmision) {
                fecha = $filter('date')(norma.fechaEmision, norma.showOnlyYear ? 'yyyy' : 'dd/MM/yyyy');
            } else {
                fecha = 'Sin fecha';
            }
            return '[ ' + norma.id + ' ] ' + fecha + ' | ' + norma.denominacion;
        }

        function agregar() {
            if (vm.modelNorma && vm.modelNorma.id && !yaElegida(vm.modelNorma.id)) {
                vm.seleccionadas.push(vm.modelNorma);
            }
            vm.modelNorma = null;
        }

        function quitar(norma) {
            var index = vm.seleccionadas.indexOf(norma);
            if (index > -1) {
                vm.seleccionadas.splice(index, 1);
            }
        }

        function save() {
            if (vm.seleccionadas.length === 0) {
                return;
            }
            vm.isSaving = true;
            var ids = vm.seleccionadas.map(function(norma) {
                return norma.id;
            });
            Norma.vincular({id: vm.vigente.id}, {ids: ids}, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
